import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { MovimientosComponent } from "./movimientos.component";
import { MovimientosService } from "./movimientos.service";
import { DataFilterPipe,DataFilterPipe2, DataFilterPipe3 } from "./movimientos.filter";

@NgModule({
    declarations: [MovimientosComponent, DataFilterPipe, DataFilterPipe2, DataFilterPipe3],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage],
    providers: [MovimientosService]

})

export class MovimientosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/movimientos/movimientos.module.ts